/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLoadBalancer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M19 7V5.414l-5 5V11h5.586l-1.292-1.293 1.414-1.414 3 3 .706.707-.707.707-3 3-1.414-1.414L19.586 13H14v.586l5 5V17h2v5h-5v-2h1.586L14 16.414V22H2V2h12v5.586L17.586 4H16V2h5v5h-2zM4 11h3.586L6.294 9.707l1.414-1.414 3 3 .707.707-.707.707-3 3-1.414-1.414L7.586 13H4v7h8V4H4v7z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLoadBalancer as LoadBalancer };
